import styled from "styled-components";
import loading from "../../assets/images/loading.gif";

export const LoadingWrapper = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 1200;
`;

export const Icon = styled.div`
  background: url(${loading}) left bottom no-repeat;
  border-radius: 6px;
  height: 46px;
  width: 46px;
`;
